import React, { useContext, useEffect, useState } from "react"
import {
  MPlayer,
  MParagraph,
  MSpan,
  ProgressBar,
  ProgressNotch,
} from "./styles"
import { PlayerContext } from "../../store/PlayerContext"
import { fancyTimeFormat } from "../../utils/index"
import { motion, useMotionValue } from "framer-motion"
import { useWindowWidth } from "@react-hook/window-size"
import PlayIcon from "./PlayIcon"

type Props = {}

const MobilePlayer: React.FC<Props> = ({}): JSX.Element => {
  const [progress, setProgress] = useState(0)
  const [onDrag, setOnDrag] = useState(false)
  const context = useContext(PlayerContext)
  const width = useWindowWidth()
  const x = useMotionValue(0)

  useEffect(() => {
    if (width && context.player.progress && !onDrag) {
      let prog = width * context.player.progress
      if (!isNaN(prog)) {
        x.set(width * context.player.progress)
      }
    }
  }, [context.player.progress])

  useEffect(() => {}, [progress])

  return (
    <MPlayer>
      <ProgressBar>
        <ProgressNotch
          style={{
            backgroundImage: `linear-gradient(90deg, #df4a32 ${
              isNaN(context.player.progress)
                ? 0
                : context.player.progress * 100 + 1
            }%, #494547 ${
              isNaN(context.player.progress)
                ? 0
                : context.player.progress * 100 + 1
            }% )`,
          }}
        >
          <motion.div
            style={{
              x: x,
            }}
            onDragEnd={(event, points) => {
              setOnDrag(false)
              //console.log("X", { updateProgress: points.point.x / width })
              context.setPlayerContext({
                type: "SET_PLAYER",
                payload: {
                  updateProgress: {
                    amount: points.point.x / width,
                    type: "fraction",
                  },
                },
              })
            }}
            onDragStart={() => {
              setOnDrag(true)
            }}
            onDragCapture={() => {
              setOnDrag(true)
            }}
            onDragEndCapture={() => {
              setOnDrag(false)
            }}
            drag="x"
          ></motion.div>
        </ProgressNotch>
      </ProgressBar>

      <MParagraph>
        {typeof context?.player?.title === "string" &&
          (context?.player?.title.split(" ").length > 9
            ? context?.player?.title.split(" ").slice(0, 9).join(" ") + " ..."
            : context?.player?.title)}

        <MSpan>
          {fancyTimeFormat(
            context.player.progress * Number(context.player.duration)
          )}
          /{fancyTimeFormat(Number(context.player.duration))}
        </MSpan>
      </MParagraph>
      <PlayIcon
        control={() => {
          ////console.log("Play")
          context.setPlayerContext({
            type: "SET_PLAYER",
            payload: {
              playing: !context.player.playing,
            },
          })
        }}
        play={context.player.playing}
      ></PlayIcon>
    </MPlayer>
  )
}

export default MobilePlayer
